import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tellent-assistant-brand-mark',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tellent-assistant-brand-mark.component.html',
  styleUrl: './tellent-assistant-brand-mark.component.less',
})
export class TellentAssistantBrandMarkComponent {}
